module.exports = __webpack_public_path__ + "img/1481983747.93a6afdf.jpg";